import React, { useEffect } from 'react';
import { Col, Row } from 'Common/Components/Grid';
import { useDispatch, useSelector } from 'react-redux';
import {
  getSummary
} from 'Screens/Dashboard/actions/Actions';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import get from 'lodash/get';
import { CLOSED_FILTERS, CONFIRMED_FLAG_FILTERS, DASHBOARD_FILTERS } from 'store/Filters/constants';
import { isFilteringBy } from 'store/Filters/selectors';
import { redirect } from 'store/Router/actions';
import {
  StyledRow, Name, Title, Value, Empty, ClickableRow
} from './styled';
import { setFilter } from 'store/Filters/actions';
/* eslint-disable consistent-return */
const Summary = () => {
  const dispatch = useDispatch();
  const workspaceSelected = useSelector(selectCurrentWorkspace);
  const data = useSelector((state) => get(state, 'dashboard.tools[3].data.stats', {}));

  const { confirmed } = CONFIRMED_FLAG_FILTERS;
  const { closed } = CLOSED_FILTERS;

  const isFilteringByConfirm = useSelector((state) => isFilteringBy(state, 'vulns', confirmed));
  const isFilteringByClosed = useSelector((state) => isFilteringBy(state, 'vulns', closed));

  useEffect(() => {
    if (!isFilteringByConfirm && !isFilteringByClosed) {
      dispatch(getSummary());
    }
  }, [dispatch, workspaceSelected, isFilteringByConfirm, isFilteringByClosed]);

  const goToAssets = () => {
    dispatch(redirect(`/host/${workspaceSelected}`));
  };

  const goToManage = () => {
    dispatch(redirect(`/manage/${workspaceSelected}`));
  };

  const goToManageWebVulns = () => {
    dispatch(setFilter('vulns', DASHBOARD_FILTERS.vulnerabilitiesByType('vulnerability_web')));

    dispatch(redirect(`/manage/${workspaceSelected}`));
  };

  return (
    <ClickableRow >
      <Col>
        <Row onClick={ goToManage }>
          <Col><Title>Workspace Summary</Title></Col>
        </Row>
        { data
          ? (
          <StyledRow>
            <Col onClick={ goToAssets }>
              <StyledRow><Value>{data.hosts}</Value></StyledRow>
              <StyledRow><Name>Assets</Name></StyledRow>
            </Col>

            <Col onClick={ goToAssets }>
              <StyledRow><Value>{data.services}</Value></StyledRow>
              <StyledRow><Name>Services</Name></StyledRow>
            </Col>

            <Col onClick={ goToManage } title="std + web">
              <StyledRow>
                <Value>{data.total_vulns || 0}</Value>
              </StyledRow>
              <StyledRow><Name>Total Vulnerabilities</Name></StyledRow>
            </Col>

            <Col onClick={ goToManageWebVulns } >
              <StyledRow>
                <Value>{data.web_vulns || 0}</Value>
              </StyledRow>
              <StyledRow><Name>Web Vulns</Name></StyledRow>
            </Col>

          </StyledRow>
            )
          : <Empty>There is no Vulnerabilities to show.</Empty> }
      </Col>
    </ClickableRow>
  );
};

export default Summary;
